import React, { Fragment } from 'react';
import { DeleteButtonWithConfirmation } from '../buttons';
import { SaveButton } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import MuiToolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withWidth from '@material-ui/core/withWidth';
import classnames from 'classnames';

const styles = theme => ({
    toolbar: {
        backgroundColor:
            theme.palette.type === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
    },
    desktopToolbar: {
        marginTop: theme.spacing(2),
    },
    mobileToolbar: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '16px',
        width: '100%',
        boxSizing: 'border-box',
        flexShrink: 0,
        zIndex: 2,
    },
    defaultToolbar: {
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
    spacer: {
        [theme.breakpoints.down('xs')]: {
            height: '5em',
        },
    },
});

const DeviceEditToolbar = ({
                               basePath,
                               children,
                               classes,
                               className,
                               handleSubmit,
                               handleSubmitWithRedirect,
                               invalid,
                               permissions,
                               pristine,
                               record,
                               redirect,
                               resource,
                               saving,
                               submitOnEnter,
                               width,
                               ...rest
                           }) => (
    <Fragment>
        <MuiToolbar
            className={classnames(
                classes.toolbar,
                {
                    [classes.mobileToolbar]: width === 'xs',
                    [classes.desktopToolbar]: width !== 'xs',
                },
                className
            )}
            role="toolbar"
            {...rest}
        >
            <div className={classes.defaultToolbar}>
                {permissions && permissions.indexOf('PatchDevice') >= 0 && (
                    <SaveButton
                        disabled={pristine}
                        handleSubmitWithRedirect={handleSubmitWithRedirect}
                        invalid={invalid}
                        redirect={redirect}
                        saving={saving}
                        submitOnEnter={submitOnEnter}
                    />
                )}
                {record && typeof record.id !== 'undefined' && permissions && permissions.indexOf('DeleteDevice') >= 0 && (
                    <DeleteButtonWithConfirmation
                        basePath={basePath}
                        record={record}
                        resource={resource}
                    />
                )}
            </div>
        </MuiToolbar>
        <div className={classes.spacer} />
    </Fragment>
);

DeviceEditToolbar.propTypes = {
    basePath: PropTypes.string,
    children: PropTypes.node,
    classes: PropTypes.object,
    className: PropTypes.string,
    handleSubmit: PropTypes.func,
    handleSubmitWithRedirect: PropTypes.func,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    record: PropTypes.object,
    redirect: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.func,
    ]),
    resource: PropTypes.string,
    saving: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    submitOnEnter: PropTypes.bool,
    width: PropTypes.string,
};

DeviceEditToolbar.defaultProps = {
    submitOnEnter: true,
};

const enhance = compose(
    withWidth(),
    withStyles(styles)
);

export default enhance(DeviceEditToolbar);
